var map = {
	"./base.webp": "75c3",
	"./battlestar.webp": "fb39",
	"./colossus.webp": "1cfc",
	"./divinewind.webp": "e78c",
	"./gunship.webp": "9889",
	"./nightstalker.webp": "e6d1",
	"./orkocraft.webp": "8ea3",
	"./salvation.webp": "440e",
	"./thunderbird.webp": "19be",
	"./ubiquity.webp": "8c67",
	"./vampship.webp": "98c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef30";